package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.DescriptionW500Rounded: ImageVector
    get() {
        if (_descriptionW500Rounded != null) {
            return _descriptionW500Rounded!!
        }
        _descriptionW500Rounded = Builder(name = "DescriptionW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(361.91f, 720.72f)
                horizontalLineToRelative(236.42f)
                quadToRelative(17.71f, 0.0f, 29.69f, -12.1f)
                reflectiveQuadTo(640.0f, 678.81f)
                quadToRelative(0.0f, -17.71f, -11.98f, -29.7f)
                quadToRelative(-11.98f, -11.98f, -29.69f, -11.98f)
                lineTo(361.67f, 637.13f)
                quadToRelative(-17.71f, 0.0f, -29.69f, 11.98f)
                quadTo(320.0f, 661.1f, 320.0f, 678.81f)
                reflectiveQuadToRelative(12.05f, 29.81f)
                quadToRelative(12.05f, 12.1f, 29.86f, 12.1f)
                close()
                moveTo(361.91f, 560.72f)
                horizontalLineToRelative(236.42f)
                quadToRelative(17.71f, 0.0f, 29.69f, -12.1f)
                reflectiveQuadTo(640.0f, 518.81f)
                quadToRelative(0.0f, -17.71f, -11.98f, -29.7f)
                quadToRelative(-11.98f, -11.98f, -29.69f, -11.98f)
                lineTo(361.67f, 477.13f)
                quadToRelative(-17.71f, 0.0f, -29.69f, 11.98f)
                quadTo(320.0f, 501.1f, 320.0f, 518.81f)
                reflectiveQuadToRelative(12.05f, 29.81f)
                quadToRelative(12.05f, 12.1f, 29.86f, 12.1f)
                close()
                moveTo(242.87f, 888.13f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadToRelative(-26.61f, -64.39f)
                verticalLineToRelative(-634.26f)
                quadToRelative(0.0f, -37.78f, 26.61f, -64.39f)
                reflectiveQuadToRelative(64.39f, -26.61f)
                lineTo(525.8f, 71.87f)
                quadToRelative(18.22f, 0.0f, 34.72f, 6.84f)
                quadToRelative(16.5f, 6.83f, 29.18f, 19.51f)
                lineTo(781.78f, 290.3f)
                quadToRelative(12.68f, 12.68f, 19.51f, 29.18f)
                quadToRelative(6.84f, 16.5f, 6.84f, 34.72f)
                verticalLineToRelative(442.93f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadToRelative(-64.39f, 26.61f)
                lineTo(242.87f, 888.13f)
                close()
                moveTo(517.13f, 317.37f)
                verticalLineToRelative(-154.5f)
                lineTo(242.87f, 162.87f)
                verticalLineToRelative(634.26f)
                horizontalLineToRelative(474.26f)
                verticalLineToRelative(-434.26f)
                horizontalLineToRelative(-154.5f)
                quadToRelative(-19.15f, 0.0f, -32.33f, -13.17f)
                quadToRelative(-13.17f, -13.18f, -13.17f, -32.33f)
                close()
                moveTo(242.87f, 162.87f)
                lineTo(242.87f, 362.87f)
                verticalLineToRelative(-200.0f)
                verticalLineToRelative(634.26f)
                verticalLineToRelative(-634.26f)
                close()
            }
        }
        .build()
        return _descriptionW500Rounded!!
    }

private var _descriptionW500Rounded: ImageVector? = null
